import React from 'react'

import ArticleHeaderInfo from '@/legacy-src/components/counselling/ArticleHeaderInfo'
import { type AuthorType } from '@/legacy-src/components/onlineLessons/types'

type Props = { title: string; isPublic?: boolean; author?: AuthorType; isBusinessPage?: boolean }

const ArticleHeader: React.FC<Props> = ({ author, isPublic, title, isBusinessPage }) => {
  return (
    <>
      <h1 className="mb-6 text-4xl font-normal laptop:text-5xl">{title}</h1>
      <ArticleHeaderInfo isPublic={isPublic} author={author} isBusinessPage={isBusinessPage} />
    </>
  )
}

export default ArticleHeader
